import * as React from 'react';
import styled from 'styled-components';
import { BREAKPOINT, GUTTER, PADDING, MARGIN, JUSTIFY_CONTENT, ALIGN_ITEMS } from '@latitude/core/utils/constants';
var StyledHorizontal = /*#__PURE__*/styled.div.withConfig({
  displayName: "Spacing__StyledHorizontal",
  componentId: "sc-5i18hy-0"
})(["display:flex;flex-direction:row;> *:not(:last-child){margin-right:", ";}"], function (_ref) {
  var cssSpacing = _ref.cssSpacing;
  return cssSpacing;
});
var StyledVertical = /*#__PURE__*/styled.div.withConfig({
  displayName: "Spacing__StyledVertical",
  componentId: "sc-5i18hy-1"
})(["display:flex;flex-direction:column;> *:not(:last-child){margin-bottom:", ";}"], function (_ref2) {
  var cssSpacing = _ref2.cssSpacing;
  return cssSpacing;
});
var StyledResponsive = /*#__PURE__*/styled.div.withConfig({
  displayName: "Spacing__StyledResponsive",
  componentId: "sc-5i18hy-2"
})(["display:flex;flex-direction:column;align-items:", ";justify-content:", ";> *:not(:last-child){margin-bottom:", ";}@media (min-width:", "){flex-direction:row;align-items:flex-start;> *:not(:last-child){margin-right:", ";margin-bottom:0;}}"], function (_ref3) {
  var alignItems = _ref3.alignItems;
  return alignItems;
}, function (_ref4) {
  var justifyContent = _ref4.justifyContent;
  return justifyContent;
}, function (_ref5) {
  var cssSpacing = _ref5.cssSpacing;
  return cssSpacing;
}, function (_ref6) {
  var breakpoint = _ref6.breakpoint;
  return breakpoint;
}, function (_ref7) {
  var cssSpacing = _ref7.cssSpacing;
  return cssSpacing;
});

var Horizontal = function Horizontal(_ref8) {
  var _ref8$spacing = _ref8.spacing,
      spacing = _ref8$spacing === void 0 ? MARGIN.M0 : _ref8$spacing,
      children = _ref8.children;
  var props = {
    cssSpacing: spacing
  };
  return /*#__PURE__*/React.createElement(StyledHorizontal, props, children);
};

var Vertical = function Vertical(_ref9) {
  var _ref9$spacing = _ref9.spacing,
      spacing = _ref9$spacing === void 0 ? MARGIN.M0 : _ref9$spacing,
      children = _ref9.children;
  var props = {
    cssSpacing: spacing
  };
  return /*#__PURE__*/React.createElement(StyledVertical, props, children);
};

var Responsive = function Responsive(_ref10) {
  var _ref10$breakpoint = _ref10.breakpoint,
      breakpoint = _ref10$breakpoint === void 0 ? BREAKPOINT.MD : _ref10$breakpoint,
      _ref10$spacing = _ref10.spacing,
      spacing = _ref10$spacing === void 0 ? MARGIN.M0 : _ref10$spacing,
      _ref10$alignItems = _ref10.alignItems,
      alignItems = _ref10$alignItems === void 0 ? ALIGN_ITEMS.CENTER : _ref10$alignItems,
      _ref10$justifyContent = _ref10.justifyContent,
      justifyContent = _ref10$justifyContent === void 0 ? JUSTIFY_CONTENT.CENTER : _ref10$justifyContent,
      children = _ref10.children;
  var props = {
    breakpoint: breakpoint,
    alignItems: alignItems,
    justifyContent: justifyContent,
    cssSpacing: spacing
  };
  return /*#__PURE__*/React.createElement(StyledResponsive, props, children);
};

export { Horizontal, Vertical, Responsive };